export default {
  loginModal: {
    width: ['100%'],
    height: ['calc(100vh - 70px)', 'calc(100vh - 70px)', 'auto'],
    overflowY: 'auto'
  },
  loginOverflow: {
    height: 'max-content'
  }
};